import { useState } from 'react';
import { Icon } from './Icon';
import { ChallengeLocation } from '../types';
import { fmtAddress, fullAddress } from '../utils/format';

/**
 * Map of the place with "Como chegar" and "Copiar endereço".
 * Uses coordinates when the API sends them; otherwise the address text (no API key needed).
 */
export function MapCard({ location }: { location: ChallengeLocation }) {
  const [copied, setCopied] = useState(false);
  const address = fullAddress(location);
  if (!address) return null;

  const hasCoords = location.lat != null && location.lng != null;
  const query = hasCoords ? `${location.lat},${location.lng}` : address;
  const mapSrc = `https://maps.google.com/maps?q=${encodeURIComponent(query)}&z=16&output=embed`;
  const directionsUrl = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(query)}`;

  async function copyAddress() {
    try {
      await navigator.clipboard.writeText(address);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // No clipboard permission: ignore.
    }
  }

  return (
    <section className="pv-card pv-map" aria-label="Mapa do local">
      <iframe
        className="pv-map__frame"
        title={`Mapa: ${address}`}
        src={mapSrc}
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      />
      <div className="pv-map__footer">
        <div>
          <div className="pv-map__address">
            {location.name || location.address}
          </div>
          <div className="pv-muted pv-small">{fmtAddress(location)}</div>
        </div>
        <div className="pv-map__actions">
          <a
            className="pv-btn pv-btn--dark"
            href={directionsUrl}
            target="_blank"
            rel="noreferrer"
          >
            <Icon name="navigation" size={17} />
            Como chegar
          </a>
          <button
            type="button"
            className="pv-btn pv-btn--ghost"
            onClick={copyAddress}
          >
            {copied ? 'Copiado!' : 'Copiar endereço'}
          </button>
        </div>
      </div>
    </section>
  );
}
